"use client";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Col } from "react-bootstrap";
import reactHtmlParser from "react-html-parser";

const MyComponent = ({ data, sectionID }) => {
  const [offset, setOffset] = useState(90);
  useEffect(() => {
    setOffset(document.querySelector(".footer .container").offsetLeft + 15);
    window.addEventListener("resize", () => {
      setOffset(document.querySelector(".footer .container").offsetLeft + 15);
    });
  }, [data]);

  return (
    <StyledComponent
      id={`${sectionID ? sectionID : ""}`}
      className={"capability"}
    >
      <div className="capability__wrap">
        <Col
          sm={7}
          className={"capability__wrap__desc"}
          style={{ paddingLeft: offset + "px" }}
        >
          <p className={"fade-up"}>
            {data?.desc && reactHtmlParser(data?.desc)}
          </p>

          {data?.list && data?.list?.length > 0 && (
            <ul className="fade-up">
              {data?.list &&
                data?.list?.length > 0 &&
                data?.list?.map((e, index) => {
                  return (
                    <li>
                      <div className="wrap">
                        <p>{reactHtmlParser(e?.item)}</p>
                      </div>
                    </li>
                  );
                })}
            </ul>
          )}
        </Col>
        <Col sm={5} className={"capability__img p-0"}>
          {data?.img && (
            <img
              className={"desktop"}
              data-speed={"clamp(1.2)"}
              src={data?.img}
              alt="why-choose"
            />
          )}
          {data?.img_mobile && (
            <img className={"mobile"} src={data?.img_mobile} alt="why-choose" />
          )}
        </Col>
      </div>
    </StyledComponent>
  );
};

const StyledComponent = styled.section`
  background-color: #fff;
  position: relative;
  &:after {
    content: "";
    position: absolute;
    height: 50%;
    width: 100%;
    top: 0;
    right: 0;
    background-color: #f4f4f4;
    /* background-color: red; */
  }

  .capability__wrap {
    display: flex;
    flex-wrap: wrap;

    position: relative;

    &__desc {
      background-color: #191919;
      padding-top: 160px;
      padding-bottom: 160px;
      padding-right: 100px;
      position: relative;
      background-repeat: repeat;
      z-index: 5;
      overflow: hidden;

      h4 {
        font-size: 28px;
        line-height: 36px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 20px;
      }

      p {
        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
        color: #ffffff;
      }

      ul {
        margin-top: 100px;
        padding-left: 100px;
        counter-reset: li-counter;

        li {
          display: flex;
          gap: 0 50px;
          align-items: flex-start;
          list-style: none; /* Remove default list style */
          position: relative;
          padding-left: 40px;
          &:before {
            content: counter(
              li-counter,
              decimal-leading-zero
            ); /* Display the counter with leading zero */
            counter-increment: li-counter; /* Increment the counter */
            position: absolute;
            left: 0;
            top: -40px;
            font-weight: 600;
            line-height: 72px;
            font-size: 68px;
            color: #8c263d; /* Change to desired color */
            z-index: -1;
            font-family: Butler;
          }

          &:not(:nth-last-of-type(1)) {
            margin-bottom: 80px;
          }

          .wrap {
            max-width: calc(100% - 60px);

            h5 {
              font-size: 16px;
              line-height: 20px;
              font-weight: 600;
              color: #ffffff;
              margin-bottom: 10px;
            }

            p {
              font-size: 16px;
              line-height: 20px;
              font-weight: 500;
              color: #fff;
            }
          }
        }
      }
    }

    .capability__img {
      position: relative;
      z-index: 5;

      img {
        width: 100%;
        object-fit: contain;
        margin-top: 100px;
      }
      .mobile {
        display: none;
      }
    }
  }

  @media (max-width: 992px) {
    .capability__wrap {
      &__desc {
        min-width: 100%;
        padding-left: 50px;
        padding-top: 100px;
        padding-bottom: 100px;

        ul {
          padding-left: 0;

          li {
            flex-wrap: wrap;

            p {
              color: #fff;
            }

            .wrap {
              min-width: 100%;
              //margin-top: 25px;
            }

            &:not(:nth-last-of-type(1)) {
              margin-bottom: 80px;
            }
          }
        }
      }

      .capability__img {
        min-width: 100%;
        img {
          margin-top: 0;
        }
      }
    }
  }

  @media (max-width: 767px) {
    .capability__wrap__desc {
      padding-left: 15px;
      padding-bottom: 120px;
      padding-top: 120px;
      padding-right: 15px;
    }
    .desktop {
      display: none;
    }
    .mobile {
      display: block !important;
    }
  }
`;

export default MyComponent;
